module.exports = __webpack_public_path__ + "img/orange_001.1dc9254b.png";